import { render, staticRenderFns } from "./survey_config_form.vue?vue&type=template&id=55aa700a&scoped=true"
import script from "./survey_config_form.vue?vue&type=script&lang=js"
export * from "./survey_config_form.vue?vue&type=script&lang=js"
import style0 from "./survey_config_form.vue?vue&type=style&index=0&id=55aa700a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa700a",
  null
  
)

export default component.exports